/* (c) Quick Pro USA (quickprousa.com) - proprietary theme code. All rights reserved. */
/* qp-rime-builds.js — per-card colour state for sections/qp-rime-builds.liquid.
   A pick on a card's dot swaps only THAT card's image, colour-name label and
   selected ring, and points only its CTA at ?variant=<first variant of that
   colour> (unless the block has a link override). Links only: never touches the
   cart. Idempotent per section node; re-runs on shopify:section:load. Without JS
   the first colour shows and the CTAs go to the plain product URL.
   Mobile carousel: the card list is a CSS scroll-snap track; this file only
   drives the pagination dashes (active dash follows scroll, rAF-throttled; a
   dash scrolls to its card) and drops the track's tabindex at 768+ where it is
   a plain grid. Without JS the track still swipes and the dashes stay hidden. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
    return;
  }
  root.QpRimeBuilds = api;
  var doc = root.document;
  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', function () { api.autoInit(doc); });
  } else {
    api.autoInit(doc);
  }
  if (!doc.__qpRimeBuildsBound) {
    doc.__qpRimeBuildsBound = true;
    doc.addEventListener('shopify:section:load', function (e) { api.autoInit(e.target || doc); });
  }
})(typeof window !== 'undefined' ? window : this, function () {
  'use strict';

  var WIDTHS = [600, 900, 1200];
  var DESKTOP = '(min-width: 768px)';
  var REDUCED = '(prefers-reduced-motion: reduce)';

  function list(nodes) { return Array.prototype.slice.call(nodes || []); }

  // Shopify image_url output carries width=N; swap it (or add it).
  function withWidth(url, w) {
    if (/([?&])width=\d+/.test(url)) return url.replace(/([?&])width=\d+/, '$1width=' + w);
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  // base URL + ?variant=<id>, replacing any variant param already there; keeps a #hash.
  function withVariant(base, id) {
    var hash = '';
    var h = base.indexOf('#');
    if (h !== -1) { hash = base.slice(h); base = base.slice(0, h); }
    base = base.replace(/([?&])variant=[^&]*(&|$)/, function (m, lead, tail) { return tail ? lead : ''; });
    base = base.replace(/[?&]$/, '');
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'variant=' + encodeURIComponent(id) + hash;
  }

  // Apply one swatch button's colour to its own card only.
  function pick(card, match) {
    if (!card || !match) return false;
    list(card.querySelectorAll('[data-qp-rime-swatch]')).forEach(function (s) {
      s.setAttribute('aria-pressed', s === match ? 'true' : 'false');
    });

    var img = card.querySelector('.qp-rime-builds__img');
    var src = match.getAttribute('data-variant-img');
    if (img && src) {
      img.srcset = WIDTHS.map(function (w) { return withWidth(src, w) + ' ' + w + 'w'; }).join(', ');
      img.src = withWidth(src, 1200);
      var alt = match.getAttribute('data-alt');
      if (alt) img.alt = alt;
    }

    var label = card.querySelector('[data-qp-rime-color-label]');
    var name = match.getAttribute('data-qp-rime-color-name');
    if (label && name && label.textContent !== name) label.textContent = name;

    var cta = card.querySelector('[data-qp-rime-cta]');
    var id = match.getAttribute('data-variant-id');
    if (cta && !cta.hasAttribute('data-qp-rime-link-override')) {
      var base = cta.getAttribute('data-base-url') || cta.getAttribute('href') || '';
      cta.setAttribute('href', id ? withVariant(base, id) : base);
    }
    return true;
  }

  function mq(win, query) {
    return win && win.matchMedia ? win.matchMedia(query) : null;
  }

  // Index of the card whose left edge sits nearest the track's scroll position;
  // pinned to the last card once the track is scrolled to its end.
  function activeIndex(track, items) {
    if (!track || !items.length) return 0;
    var left = track.scrollLeft;
    var max = track.scrollWidth - track.clientWidth;
    if (max > 0 && left >= max - 2) return items.length - 1;
    var best = 0;
    var bestDist = Infinity;
    items.forEach(function (it, i) {
      var d = Math.abs(it.offsetLeft - items[0].offsetLeft - left);
      if (d < bestDist) { bestDist = d; best = i; }
    });
    return best;
  }

  function setActive(dashes, idx) {
    dashes.forEach(function (d, i) {
      if (i === idx) d.setAttribute('aria-current', 'true');
      else d.removeAttribute('aria-current');
    });
  }

  function initCarousel(section) {
    var track = section.querySelector('[data-qp-rime-track]');
    if (!track) return null;
    var items = list(track.children);
    var dashes = list(section.querySelectorAll('[data-qp-rime-dash]'));
    var win = section.ownerDocument && section.ownerDocument.defaultView;

    var desk = mq(win, DESKTOP);
    function syncTabStop() {
      if (desk && desk.matches) track.removeAttribute('tabindex');
      else track.setAttribute('tabindex', '0');
    }
    syncTabStop();
    if (desk) {
      if (desk.addEventListener) desk.addEventListener('change', syncTabStop);
      else if (desk.addListener) desk.addListener(syncTabStop);
    }

    if (!dashes.length) return { update: function () {} };

    var raf = (win && win.requestAnimationFrame) ? win.requestAnimationFrame.bind(win) : function (fn) { return setTimeout(fn, 16); };
    var queued = false;
    function update() {
      queued = false;
      setActive(dashes, activeIndex(track, items));
    }
    track.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      raf(update);
    }, { passive: true });

    dashes.forEach(function (dash) {
      dash.addEventListener('click', function () {
        var i = parseInt(dash.getAttribute('data-qp-rime-dash'), 10) || 0;
        var it = items[i];
        if (!it) return;
        var reduced = mq(win, REDUCED);
        var left = it.offsetLeft - items[0].offsetLeft;
        var behavior = reduced && reduced.matches ? 'auto' : 'smooth';
        if (track.scrollTo) track.scrollTo({ left: left, behavior: behavior });
        else track.scrollLeft = left;
        setActive(dashes, i);
      });
    });

    return { update: update };
  }

  function init(section) {
    if (!section || section.__qpRimeBuilds) return section && section.__qpRimeBuilds;
    var ctl = {};
    section.__qpRimeBuilds = ctl;
    section.setAttribute('data-qp-rime-ready', '');
    section.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest && e.target.closest('[data-qp-rime-swatch]');
      if (!btn || !section.contains(btn)) return;
      pick(btn.closest('[data-qp-rime-card]'), btn);
    });
    ctl.carousel = initCarousel(section);
    return ctl;
  }

  function autoInit(scope) {
    var base = scope && scope.querySelectorAll ? scope : null;
    if (!base) return [];
    var found = list(base.querySelectorAll('[data-qp-rime-builds]'));
    if (base.matches && base.matches('[data-qp-rime-builds]')) found.unshift(base);
    return found.map(init);
  }

  return { init: init, autoInit: autoInit, pick: pick, activeIndex: activeIndex, withVariant: withVariant, withWidth: withWidth };
});
